@if (data$ | async; as report) {
    <a class="sh-list-row-title" [routerLink]="report.key" [title]="report.naam">
        <h3 class="sh-list-row-title__title -sh-wrap">{{ report.naam }}</h3>
    </a>
}
